module.exports = __webpack_public_path__ + "static/media/ready-pickup-icon-card.e7f7c80e.svg";